import {
  aesDecrypt,
  aesEncrypt,
  dataSign,
  generateRandomString,
  generateUUID,
  isPlainObject,
  md5Hash,
  rsaDecrypt,
  rsaEncrypt,
} from '@dcb/utils'
import { currentApiMall } from '@/mall'
import { currentChannelId, currentSaleChannelId } from '@/channel'
import { dcb } from '@dcb/jssdk'
import { globalModel } from '@/model'
import { onPageVisibilityChange } from '@/utils/on_page_visibility_change'
import { signal } from 'vtils'

const clientType = globalModel.state.inLove
  ? '5'
  : globalModel.state.inWeapp
  ? '3'
  : globalModel.state.inWechatWebView
  ? '2'
  : '1'
const clientId = globalModel.state.isTV ? '07' : '03'
const appKey = globalModel.state.isTV
  ? '8AAA8A7E771AAC0701771E5B6372009B'
  : currentApiMall.app_key
const appSecret = currentApiMall.app_secret
const requestRsaPublicKey = currentApiMall.request_rsa_public_key
const responseRsaPublicKey = currentApiMall.response_rsa_public_key
const secret = '4RBA7^@0$@KM$5D2333'
const noEncryptSign = 'WrASY3sEGK!4DE@h'
const testP = ''
const pSignal = signal<string>()
// const testP =
//   'aIXxPYVlELY9ygHgrxeoUZ0vxzftPnW%2bdvdnqnEYpvWMmJVI6cLLIHV2WW%2b%2bf9W2tH1EN%2bF3%2f9PHhQ5vjYg3%2b3KuI7v3fayqD9a4cS68KP8383fjXprYnLLv%2b2f%2bC2RZJbA8Dx9nOa2sw2IT0WJ7MWEAVgAP7ydUAj83wMMJm%2bUWaFt5tbwkm9YP59joUv9hIgXqHmM7LtGTXrqlC8zPCdix0TkYkidLw3ZdRwDVsg8LtTuVgXGFRktMgTVxjFzHASasUDRNlfWkexUipK8VJKrhuM1dW5vCqrGnSnwXj6KG%2fnOOVjJp6g%2bu7OtyDfUpxNxvR4iMpG1yQKqUe3bBvg%3d%3d'
let p = setP(
  testP ||
    location.href.match(/[?&]p=(.*?)([#&\b]|$)/)?.[1] ||
    localStorage.getItem('__p__') ||
    '',
)

if (!globalModel.state.inWeapp) {
  // 隐藏窗口显示时刷新 p 参数
  onPageVisibilityChange(() => {
    dcb.getP().then(res => {
      console.log('p参数6666-------', {
        oldP: p,
        newP: res.p || p,
      })
      console.log(res.p)
      setP(res.p || p)
    })
  })
}

export function getP() {
  return p
}

export async function ensureP() {
  return pSignal.get()
}

/** 设置 P */
export function setP(_p: string) {
  // 兼容外部传入的 p 不符合规范的情况
  _p = _p === 'undefined' || _p === 'null' ? '' : _p
  _p = (_p.includes('%') ? decodeURIComponent(_p) : _p)
    .replace(/ /g, '+')
    // 兼容接口返回的 p 存在空字符的情况
    .replace(/\s+/g, '')
  p = _p
  localStorage.setItem('__p__', _p)
  if (_p) {
    pSignal.set(_p)
  }
  return _p
}
// @ts-ignore
window.__dcbSetP__ = setP

// ref: http://wiki.gogpay.cn/pages/viewpage.action?pageId=30802491
// init 存储密钥
// base 存储数据
export async function encryptHttpRequestData(
  data: any,
  noEncrypt = false,
): Promise<any> {
  return data
  if (noEncrypt) {
    return data
  }

  // TV 端
  if (globalModel.state.isTV && !globalModel.state.isTVSimulate) {
    return dcb.tvGetRsaEnData({
      body: JSON.stringify(data),
    })
  }

  // 移动端
  // 第一步,生成32位随机流水号生成字段timestamp:1c129b18e781464eb0d56babd25fdddd
  const timestamp = generateUUID().replace(/-/g, '')
  // 第二步, timestamp+secret:1c129b18e781464eb0d56babd25fdddd4RBA7^@0$@KM$5D2333
  // 第三步, 对第二步结果进行32位MD5加密转小写生成字段title:b9e31acde4afc03c0f2ee9b7f3e9f367
  const title = md5Hash(timestamp + secret)
  // 第四步,把业务参数JSON对象转换为字符串:{"userId":"doit"}
  const dataStr = JSON.stringify(data)
  // 第五步,生成16位随机密钥aesKey:hj7Wer8V3epukzV7
  const aesKey = generateRandomString(16)
  // 第六步,利用RSA公钥加密aesKey生成字段init:yQKUR+C/f4Y9T7WidtK/ycoz1C/65yqpjjmqBFffgmmBlEeSOmQaQWAdiIaITw4PXEZONVonyKhyk22d+FH55yLKImatCTnbYIU5wQ9DOkGtnwYGTLLpXwdHDNJoEthHZ2e31mNrZanLmQv92tw8BFeqrsngYsP4fqbAEGlLNE11RYM9hPB1/asDf4Fk/BEjH4zp4TcMv+uRD6ReC8QlUSZDBHHf/r6UHgd5FZJA4kmj5SOG5lgPOEL7qmWRq8GNNpJTZ5lbXmA/GjPMA0muXyARdekF0MnMwEooDdv22s2HvpgLPQq4C/gxvxtXPw+5E4AK42cLFskmWdtkRLxo6w==
  const init = rsaEncrypt(aesKey, requestRsaPublicKey)
  // 第七部步,利用AES加密业务数据生成字段base:fCH/NJMbVFVDjL73irkG40HP19muCpVcrrUrx22GuEc=
  const base = aesEncrypt(dataStr, aesKey)
  return { title, timestamp, init, base }
}

export async function decryptHttpResponseDataIfNeeded(data: {
  init: string
  base: string
}): Promise<any> {
  if (isPlainObject(data) && data.init && data.base) {
    // TV 端
    if (globalModel.state.isTV && !globalModel.state.isTVSimulate) {
      return dcb
        .tvGetRsaDeData({
          response: data as any,
        })
        .then(res => {
          try {
            return JSON.parse(res as any)
          } catch {
            return res
          }
        })
    }

    // 移动端
    const aesKey = rsaDecrypt(data.init, responseRsaPublicKey)
    return JSON.parse(aesDecrypt(data.base, aesKey))
  }
  return data
}

export async function prepareRequestHeaders(
  requestPath: string,
  noEncrypt = false,
  noP = false,
  hasStoreCode = false,
  businessChannel = '',
): Promise<Record<string, string>> {
  const commonHeaders = {
    // 运营渠道，来自地址参数中的 refUserGroupId
    'business-channel': businessChannel || currentChannelId,
    // 销售渠道，来自地址参数中的 sellChannelId
    'sale-channel': currentSaleChannelId,
    // 分发渠道：0 TV端 1 移动端
    'distribute-channel': globalModel.state.isTV ? '0' : '1',
    // 商家端店铺 code
    'X-Store-Code': hasStoreCode
      ? localStorage.getItem('X-Store-Code') || ''
      : '',
    'x-client-type': clientType,
  }

  // TV 端
  if (globalModel.state.isTV && !globalModel.state.isTVSimulate) {
    const Authorization =
      // @ts-ignore
      (typeof unifyQrCode !== 'undefined' &&
        // @ts-ignore
        unifyQrCode.tool.tvH5token) ||
      (await dcb.tvGetAuthToken())
    return {
      ...commonHeaders,
      'path': requestPath,
      'Authorization': Authorization.acctoken || '',
      ...(await dcb.tvGetSignHeader({
        clientId,
        appKey,
      })),
      'client-id': clientId,
      'app-key': appKey,
    }
  }

  // 移动端
  const timestamp = Date.now().toString()
  const headers = {
    clientId: clientId,
    path: requestPath,
    timestamp: timestamp,
  }
  const sign = noEncrypt ? noEncryptSign : dataSign(headers, appSecret)
  return {
    ...commonHeaders,
    ...headers,
    appKey,
    sign,
    ...(noP ? {} : { p }),
  }
}
